import { render, staticRenderFns } from "./EditUserAddress.vue?vue&type=template&id=e5d1e5ea&scoped=true"
import script from "./EditUserAddress.vue?vue&type=script&lang=js"
export * from "./EditUserAddress.vue?vue&type=script&lang=js"
import style0 from "./EditUserAddress.vue?vue&type=style&index=0&id=e5d1e5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d1e5ea",
  null
  
)

export default component.exports